<div class="row g-0">
  <div class="col-md-4 gradient-custom text-center text-white"
       style="border-top-left-radius: .5rem; border-bottom-left-radius: .5rem;">
    <img src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3-bg.webp" alt="Avatar"
         class="img-fluid mt-5 m-auto" style="width: 80px;"/>
    <div class="card-body text-center">
      <h4 class="mb-2" style="font-weight: bold;">{{firstName}} {{ lastName}}</h4>
      <p class="mb-4">&#64;<a>{{company}}</a></p>

    </div>
  </div>
  <div class="col-md-8">
    <div class="modal-header">
      <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="card-body p-4">
      <h6 class="fw-bold">Contact Information</h6>
      <hr class="mt-0 mb-4">
      <div class="row pt-1">
        <div class="col-6 mb-3">
          <h6>Email</h6>
          <p class="text-muted text-truncate">{{email}}</p>
        </div>
        <div class="col-6 mb-3">
          <h6>Phone Number</h6>
          <p class="text-muted text-truncate">{{contactNo}}</p>
        </div>
        <div class="col-6 mb-3">
          <h6>Username</h6>
          <p class="text-muted text-truncate">{{username}}</p>
        </div>
      </div>
      <h6 class="fw-bold">Others</h6>
      <hr class="mt-0 mb-4">
      <div class="row pt-1">
        <div class="col-6 mb-3">
          <h6>Company Name</h6>
          <p class="text-muted text-truncate">{{company}}</p>
        </div>
      </div>

      <div class="col-6 mb-3">
        <h6>Preferred APIs</h6>
        <div class="general-checkBox" >
          <input onclick="return false;"  type="checkbox" id="GtnApiEnableCheck" ng-model="check" [(ngModel)]="openAPIEnabled" />
          GTN Fintech APIs
        </div>
        <div class="general-checkBox" >
          <input onclick="return false;"  type="checkbox" id="EmbedApiEnableCheck" ng-model="check" [(ngModel)]="embedAPIEnabled"/>
          GTN Embed APIs
        </div>
        <div class="general-checkBox" >
          <input onclick="return false;"  type="checkbox" id="AccountApiEnableCheck" ng-model="check" [(ngModel)]="backOfficeAPIEnabled"/>
          GTN Backoffice APIs
        </div>
        <div class="general-checkBox" >
          <input onclick="return false;"  type="checkbox" id="DwmApiEnableCheck" ng-model="check" [(ngModel)]="dwmAPIEnabled"/>
          GTN DWM APIs
        </div>
        <div class="general-checkBox" >
          <input onclick="return false;"  type="checkbox" id="FeedApiEnableCheck" ng-model="check" [(ngModel)]="feedAPIEnabled"/>
          GTN Market Data APIs
        </div>
        <!--          <p class="text-muted">{{apis}}</p>-->
      </div>
    </div>
  </div>
</div>
